import React from "react";
import styles from "./ScrollDecorations.module.scss";

const marks = [
  { top: "5%", right: "16px", rotate: "-7deg", width: 34, tone: "sky" },
  { top: "16%", right: "34px", rotate: "5deg", width: 22, tone: "mint" },
  { top: "28%", right: "12px", rotate: "-4deg", width: 42, tone: "sky" },
  { top: "40%", right: "38px", rotate: "8deg", width: 28, tone: "gold" },
  { top: "53%", right: "14px", rotate: "-6deg", width: 36, tone: "mint" },
  { top: "66%", right: "32px", rotate: "4deg", width: 24, tone: "sky" },
  { top: "79%", right: "10px", rotate: "-5deg", width: 44, tone: "gold" },
  { top: "91%", right: "36px", rotate: "7deg", width: 26, tone: "sky" },
];

const answerDots = [
  { top: "7%", left: "18px", label: "A", tone: "sky" },
  { top: "18%", left: "38px", label: "B", tone: "empty" },
  { top: "30%", left: "14px", label: "C", tone: "mint" },
  { top: "42%", left: "42px", label: "D", tone: "empty" },
  { top: "55%", left: "16px", label: "A", tone: "gold" },
  { top: "68%", left: "36px", label: "C", tone: "sky" },
  { top: "80%", left: "12px", label: "B", tone: "empty" },
  { top: "92%", left: "40px", label: "D", tone: "mint" },
];

function ScrollDecorations() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const updateProgress = () => {
      const scrollable =
        document.documentElement.scrollHeight - window.innerHeight;
      setProgress(scrollable > 0 ? window.scrollY / scrollable : 0);
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);

    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("resize", updateProgress);
    };
  }, []);

  return (
    <div aria-hidden="true">
      <div className={styles.answerDots}>
        {answerDots.map((dot, index) => {
          const visible = progress >= index / answerDots.length - 0.02;

          return (
            <span
              key={`${dot.top}-${dot.left}`}
              className={`${styles.answerDot} ${styles[dot.tone]}`}
              style={{
                top: dot.top,
                left: dot.left,
                opacity: visible ? 1 : 0,
                transform: visible
                  ? "translateY(0) scale(1)"
                  : "translateY(14px) scale(0.72)",
                transitionDelay: visible ? `${index * 48}ms` : "0ms",
              }}
            >
              {dot.label}
            </span>
          );
        })}
      </div>

      <div className={styles.marks}>
        {marks.map((mark, index) => {
          const visible = progress >= index / marks.length - 0.02;

          return (
            <span
              key={`${mark.top}-${mark.right}`}
              className={`${styles.mark} ${styles[mark.tone]}`}
              style={{
                "--mark-width": `${mark.width}px`,
                top: mark.top,
                right: mark.right,
                opacity: visible ? 1 : 0,
                transform: visible
                  ? `translateY(0) rotate(${mark.rotate}) scaleX(1)`
                  : `translateY(14px) rotate(${mark.rotate}) scaleX(0.18)`,
                transitionDelay: visible ? `${index * 42}ms` : "0ms",
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ScrollDecorations;
